"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftView = void 0;
const react_1 = __importDefault(require("react"));
const audio_view_1 = require("./audio-view");
const image_view_1 = require("./image-view");
const model_view_1 = require("./model-view");
require("./styles.scss");
const video_view_1 = require("./video-view");
const NftView = (props) => {
    const { mediaType, metaUrlBase, metadata, eventHandler } = props;
    if (!metadata) {
        return null;
    }
    const playHandler = () => eventHandler("play");
    const pauseHandler = () => eventHandler("pause");
    switch (mediaType) {
        case "3d":
            return react_1.default.createElement(model_view_1.ModelView, { metaUrlBase: metaUrlBase, metadata: metadata, onPlay: playHandler });
        case "audio":
            return react_1.default.createElement(audio_view_1.AudioView, { metaUrlBase: metaUrlBase, metadata: metadata, onPlay: playHandler });
        case "image":
            return react_1.default.createElement(image_view_1.ImageView, { metaUrlBase: metaUrlBase, metadata: metadata });
        case "video":
            return react_1.default.createElement(video_view_1.VideoView, { metaUrlBase: metaUrlBase, metadata: metadata, onPause: pauseHandler, onPlay: playHandler });
        default:
            return react_1.default.createElement("span", null, "Unknown media type");
    }
};
exports.NftView = NftView;
